export const typePrefix = {
  GET_FEEDBACK_OVERVIEW: 'GET_FEEDBACK_OVERVIEW',
}
